export const MERGE_PROGRESS = {
    FETCH: 0,
    MERGE: 1,
    CHECK: 2
}